export * from './service/index.js'
export * from './migrations/index.js'
export * from './controllers/index.js'

import './routes.js'

import { getPermission } from '@things-factory/operato-license-checker'

export function initMiddlewares(app) {
  const licensedPermissions = (getPermission('Permissions For Board Usage') || 'Modeller, Viewer')
    .split(',')
    .map(p => p.trim())

  const prohibited = !licensedPermissions.includes('Modeller') && [
    {
      privilege: 'mutation',
      category: 'board'
    },
    {
      privilege: 'mutation',
      category: 'board-template'
    }
  ]

  /*
   * board-permission을 prohibitedPrivileges에 반영한다.
   */
  app.use(async (context, next) => {
    if (prohibited) {
      const { prohibitedPrivileges } = context.state

      context.state.prohibitedPrivileges = [...(prohibitedPrivileges || []), ...prohibited]
    }
    await next()
  })
}
